import React, { useEffect, useCallback, useState} from 'react';
import {Knob, Arc, Pointer, Value} from 'components/rc-knob/index.js';
import {connect} from 'react-redux';

const PanKnob = ({track, panning, scrollContainer}) => { 
    const onChange = useCallback((v) => {
        document.activeElement.blur();
        track.setPanning(v);
    }, [track]);

    return (
        <div className="pan-knob">
          <Knob 
            scrollContainer={scrollContainer}
            size={30}  
            angleOffset={220} 
            angleRange={280}
            value={panning}
            initialValue={panning}
            step={0.01}
            min={-1}
            max={1}
            onChange={onChange}
          >
            <Arc 
              arcWidth={2}
              color={"#6c757a"}
              background="#6c757a"
            />
            <Pointer 
              width={2} 
              height={10}
              radius={4}
              type="rect"
              color={"white"}
            />
          </Knob>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      panning: state.tracks.trackPannings[props.track.trackNumber] || 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PanKnob);
